module.exports = __webpack_public_path__ + "img/72.ae8a7c7d.png";